import Vue from 'vue'
import Vuex from 'vuex'

import auth from '@/store/modules/auth.module'
import payments from '@/store/modules/payments.module'
import msgCenter from '@/store/modules/messageCenter.module'
import profile from '@/store/modules/profile.module'
import paymentMethods from '@/store/modules/paymentMethods.module'
import dashboard from '@/store/modules/dashboard.module'
import discussion from '@/store/modules/discussion.module'
import payExpense from '@/store/modules/payExpense.module'
import reports from '@/store/modules/reports.module'
import calendar from '@/store/modules/calendar.module'
import notifications from '@/store/modules/notifications.module'
import nlp from '@/store/modules/nlp.module'
import appLayout from '@/store/modules/appLayout.module'
import preferences from '@/store/modules/preferences.module'
import registrationProgress from '@/store/modules/registrationProgress.module'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    auth,
    payments,
    msgCenter,
    profile,
    paymentMethods,
    dashboard,
    discussion,
    payExpense,
    reports,
    calendar,
    notifications,
    nlp,
    appLayout,
    preferences,
    registrationProgress
  }
})
